<template>
  <div class="form-group phone-form-group relative mb-0" :class="{ 'form-group-invalid': errors.length }">
    <input
      id="fast-project-phone"
      ref="input"
      v-model="phone"
      type="text"
      class="form-control h-auto rounded-lg py-4"
      :class="{ 'is-invalid': errors.length }"
      tabindex="-1"
      autocomplete="off"
      :required="required"
      @countrychange="phone = value"
    />
    <span v-show="state === 'valid'" class="fast-phone-indicator absolute bottom-[20px] right-[13px] text-white">
      <fa-icon type="fas" icon="check" class="text-success" />
    </span>
    <span
      v-show="state === 'invalid'"
      class="fast-phone-indicator absolute bottom-[20px] right-[13px] text-white"
      title="Votre numéro de téléphone est invalide et ne pourra pas être pris en compte"
    >
      <fa-icon type="far" icon="exclamation-triangle" class="text-warning" />
    </span>
    <div v-if="errors.length" class="invalid-feedback">Votre numéro de téléphone {{ errors | toSentence }}</div>
  </div>
</template>

<script>
import intlTelInput from 'intl-tel-input'
import { INTL_TEL_INPUT_UTILS_URL } from '@/utils/constants'
import '@stylesheets/lib/elements/_phone_input.scss'

export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    defaultCountry: {
      type: String,
      default: 'FR'
    },
    required: {
      type: Boolean,
      default: false
    },
    errors: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      telInput: null,
      state: 'unused'
    }
  },
  computed: {
    phone: {
      get() {
        return this.value
      },
      set(value) {
        if (!this.telInput) return
        let cleaned = null

        if (this.telInput.isValidNumber()) {
          cleaned = this.telInput.getNumber()
          this.state = 'valid'
        } else {
          this.state = this.value.length ? 'invalid' : 'unused'
        }

        this.$emit('input', { value, cleaned })
      }
    }
  },
  mounted() {
    this.telInput = intlTelInput(this.$refs.input, {
      utilsScript: INTL_TEL_INPUT_UTILS_URL,
      formatOnDisplay: false,
      separateDialCode: false,
      nationalMode: true,
      defaultCountry: this.defaultCountry,
      preferredCountries: ['fr', 'be', 'ca', 'ch', 'dz', 'ma', 'mg', 'tn'],
      customPlaceholder(selectedCountryPlaceholder) {
        return 'Ex : ' + selectedCountryPlaceholder.replace(/\s+/g, '')
      }
    })

    setTimeout(() => (this.phone = this.value), 150)
  }
}
</script>
